// extracted by mini-css-extract-plugin
export default {"tips":"n8fx1Dh_KwxoHGbOl5Z6","button":"UPlrO7x0pc8wsiPKildm"};